import React from 'react';
import { useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling

const TermsOfUse = () => {
  const { lang } = useParams();
  const termsHtml = `
  <div dir="rtl">
    <h1>תנאי שימוש — SeegSoog.com</h1>
    <p><strong>תאריך כניסה לתוקף:</strong> 11 בדצמבר, 2025</p>
    <p>SeegSoog.com מופעלת על ידי חברת לוג-אין הבית החכם בע"מ, מספר ח.פ. 514147305, ישראל. כל הפעולות המשפטיות הקשורות ל-SeegSoog.com יופנו לחברה זו בלבד.</p>

    <p>ברוכים הבאים ל-SeegSoog.com ("אנו", "אנחנו" או "שלנו"). תנאי שימוש אלה ("התנאים") חלים על השימוש שלך באתר האינטרנט שלנו ובשירותים הנלווים (ביחד, "הפלטפורמה"). על ידי גישה או שימוש בפלטפורמה, אתה מסכים לציית לתנאים אלה.</p>
    
    <p><strong>היקף השירותים:</strong> הפלטפורמה היא זירה מקוונת המאפשרת למשתמשים לאתר נכסים, להתחבר למשתמשים אחרים ולתקשר לגבי עסקאות ושירותים פוטנציאליים. אלה עשויים לכלול, ללא הגבלה, מכירות והשקעות בנכסים, הסדרי מימון והלוואות פרטיים (כגון "היה הבנק", משכנתאות, הלוואות גישור או הלוואות אחרות), ושירותים הקשורים לנדל"ן של צד שלישי (כגון בנייה ושיפוצים, בדיקות, הקמת חברה או LLC ושירותי סוכן רשום, שירותי טאבו וליווי עסקאות, ביטוח, ניהול נכסים, ראיית חשבון, שירותים משפטיים, תכנון מס, החלפות 1031 והצעות דומות). כל תקשורת, משא ומתן, הסכם או עסקה שאתה מבצע עם משתמש אחר או ספק היא אך ורק בינך לבין אותו צד.</p>

    <h2>1. זכאות</h2>
    <p>עליך להיות בן 18 לפחות כדי להירשם ולהשתמש בשירותינו.</p>

    <h2>2. חשבונות וכניסה</h2>
    <ul>
      <li>אתה אחראי לשמירה על סודיות פרטי הכניסה שלך.</li>
      <li>אל תשתף את חשבונך או תתחזה לאדם אחר.</li>
    </ul>

    <h2>3. תפקידי משתמשים</h2>
    <p>הפלטפורמה נועדה לחבר בין סוגים שונים של משתמשים. אנו מגדירים תפקידים אלה באופן הבא:</p>
    <ul>
      <li><strong>משקיעים:</strong> משתמשים המעוניינים לאתר, לנתח וליצור קשר עם ספקים בנוגע לנכסים ושירותים נלווים.</li>
      <li><strong>ספקים:</strong> מונח כללי לכל משתמש המציע נכס או שירות. זה כולל <strong>מוכרים</strong>, המפרסמים נכסים למכירה או להשקעה, ו<strong>נותני שירותים</strong>, שעשויים להציע שירותים כגון מימון, בנייה, ייעוץ משפטי או ניהול נכסים.</li>
    </ul>
    <p>כדי להציע נכסים או שירותים כספק, עליך להסכים גם ל<a href="/${lang}/provider-terms-of-use">תנאי השימוש למוכר</a>.</p>

    <h2>4. דוחות ניתוח שנוצרו בעזרת בינה מלאכותית</h2>
    <p>הפלטפורמה מציעה דוחות נכסים שנוצרו בעזרת בינה מלאכותית למטרות מידע בלבד. דוחות אלה נוצרים על ידי מערכות אוטומטיות ועשויים להכיל אי-דיוקים או השמטות. <strong>SeegSoog.com אינה אחראית לתוכן, לדיוק או לשלמות של דוחות אלה.</strong> עליך לאמת באופן עצמאי כל מידע לפני קבלת החלטות פיננסיות.</p>

    <h2>5. נכסים שמורים</h2>
    <p>משתמשים יכולים לסמן נכסים המופיעים הן במפה והן בסרגל הצד.</p>

    <h2>6. שימוש מקובל</h2>
    <ul>
      <li>אין להשתמש בפלטפורמה למטרות בלתי חוקיות, פוגעניות או הונאתיות.</li>
      <li>אין לגרד, להעתיק או להפיץ מחדש תוכן ללא רשות.</li>
    </ul>

    <h2>7. קניין רוחני</h2>
    <p>כל תוכן האתר והמיתוג הם בבעלות SeegSoog.com. שכפול או הפצה מחדש ללא אישור אסורים.</p>

    <h2>8. פרטיות</h2>
    <p>עיין ב<a href="/${lang}/privacy-policy">מדיניות הפרטיות</a> שלנו לפרטים על איסוף ושימוש בנתונים.</p>

    <h2>9. כתב ויתור</h2>
    <p>SeegSoog.com אינה מבטיחה תוצאות השקעה או ביצועי נכסים. איננו אחראים להפסדים או לשגיאות בנתוני הרישום. ספקים ומשקיעים מקבלים אחריות על החלטותיהם.</p>
    <p><strong>תפקידנו ואי-מתן ייעוץ:</strong> איננו מתווכי נדל"ן, סוכנים, מלווים, חתמים, מבטחים, נאמני escrow, יועצי השקעות, יועצים משפטיים או יועצי מס, או נאמנים. איננו מבנים, יוזמים, חותמים, מתווכים או ערבים להלוואות, הסדרי מימון או שירותים אחרים שעשויים להידון או להיחתם בין משתמשים או עם ספקים אחרים. איננו מנסחים, בודקים, מנהלים משא ומתן או תומכים בהסכמי הלוואה, חוזי שירות או מסמכים משפטיים אחרים בינך לבין כל צד אחר, ואיננו מציגים מצג כלשהו לגבי חוקיותם, תוקפם, אכיפותם או התאמתם. אתה האחראי הבלעדי לקבלת ייעוץ משפטי, מס, פיננסי ומקצועי עצמאי משלך לפני כניסה לכל עסקה.</p>

    <h2>10. הגבלת אחריות</h2>
    <p>במידה המרבית המותרת על פי חוק, SeegSoog.com, שותפיה, ונושאי המשרה, הדירקטורים, העובדים והסוכנים שלהם לא יהיו אחראים לכל נזקים עקיפים, מקריים, מיוחדים, תוצאתיים או עונשיים, או לכל אובדן רווחים או הכנסות, בין אם נגרמו במישרין או בעקיפין, או לכל אובדן נתונים, שימוש, מוניטין או הפסדים בלתי מוחשיים אחרים, הנובעים מ-(א) גישתך או שימושך או חוסר יכולתך לגשת או להשתמש בפלטפורמה; (ב) כל התנהגות או תוכן של צד שלישי כלשהו בפלטפורמה; או (ג) גישה, שימוש או שינוי בלתי מורשים של העברותיך או תוכנך.</p>

    <h2>11. שירותי צד שלישי ותשלומים</h2>
    <p>הפלטפורמה עשויה להציג מידע אודות, או לאפשר לך להתחבר עם, ספקים שעשויים להציע מימון, בנייה, בדיקה, ניהול, שירותים משפטיים, מס, ביטוח או שירותים אחרים. איננו שולטים, מפקחים, ממליצים או ערבים לאף ספק כזה. כל ריבית, עמלות, עמלות תיווך, פרמיות, מקדמות או סכומים אחרים המוסכמים בינך לבין צד אחר נקבעים אך ורק על ידך ועל ידי אותו צד. אלא אם כן נציין בבירור אחרת בכתב עבור תכונה ספציפית, איננו מחזיקים בכספי לקוחות, איננו פועלים כנאמני escrow, ואיננו אחראים להעברה או לשמירה על כסף או נכסים כלשהם. אתה האחראי הבלעדי לאימות הרישוי, הרישום, הניסיון והציות של כל צד שתבחר לעבוד איתו.</p>

    <h2>12. תקופה וסיום</h2>
    <p>תוכל לסיים את חשבונך בכל עת על ידי ביצוע ההוראות בהגדרות החשבון שלך או על ידי יצירת קשר ישיר איתנו. אנו שומרים לעצמנו את הזכות להשעות או לסיים את גישתך לפלטפורמה לפי שיקול דעתנו הבלעדי, ללא הודעה מוקדמת, בגין כל התנהגות שאנו סבורים שהיא מפרה תנאים אלה או מזיקה למשתמשים אחרים בפלטפורמה, לנו או לצדדים שלישיים. ההשלכות על הפרות עשויות לכלול, אך לא רק, אזהרה רשמית, השעיה זמנית או סיום קבוע של חשבונך.</p>

    <h2>13. שיפוי</h2>
    <p>אתה מסכים לשפות, להגן ולהחזיק את SeegSoog.com ואת שותפיה חפים מכל תביעה, נזק או הוצאה, לרבות שכר טרחת עורכי דין סביר, הנובעים מהשימוש שלך בפלטפורמה או מהפרתך של תנאים אלה.</p>

    <h2>14. חוק חל ויישוב סכסוכים</h2>
    <p>תנאים אלה יחולו בהתאם לחוקי מדינת ישראל. אנו ממליצים לך ליצור איתנו קשר תחילה כדי לפתור כל סכסוך באופן לא רשמי. עם קבלת הודעת סכסוך דרך דף <a href="/${lang}/contact-us">צור קשר</a> שלנו, נעשה מאמץ בתום לב לפתור אותו ונשיב לפנייתך תוך 14 ימי עסקים. כל תביעה משפטית הנובעת מתנאים אלה תובא באופן בלעדי לבתי המשפט המוסמכים הממוקמים בתל אביב, ישראל.</p>

    <h2>15. שינויים בתנאים</h2>
    <p>התנאים עשויים להתעדכן מעת לעת. המשך השימוש מרמז על הסכמה לגרסה העדכנית ביותר.</p>

    <h2>16. יצירת קשר</h2>
    <p>לשאלות או חששות, אנא השתמש בדף <a href="/${lang}/contact-us">צור קשר</a> שלנו.</p>
  </div>
  `;

  return (
    <div className="legal-page-container">
      <div className="legal-content" dangerouslySetInnerHTML={{ __html: termsHtml }} />
    </div>
  );
};

export default TermsOfUse;
